import { Reveal, Eyebrow } from "./Reveal";
import { buildSteps } from "../data/products";

const principles = [
  "Research-informed",
  "Human-centered",
  "Commercially considered",
  "Built, tested, refined",
];

export const StudioPrinciples = () => {
  return (
    <section
      id="how-we-build"
      data-testid="studio-principles"
      className="bg-canvas"
    >
      <div className="mx-auto max-w-6xl px-6 py-12 md:py-16 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>How We Build</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-3 font-bold tracking-tight text-ink text-[clamp(1.9rem,4vw,2.25rem)]">
              A repeatable way to ship focused products.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 max-w-xl text-[16px] leading-relaxed text-slatetx">
              We start with real user problems, understand the context, and
              build the smallest useful product around what matters most.
            </p>
          </Reveal>
        </div>

        {/* Four-step methodology */}
        <div className="mt-8 grid gap-px overflow-hidden rounded-[22px] border border-hairline bg-hairline sm:grid-cols-2 md:mt-10 lg:grid-cols-4">
          {buildSteps.map((step, i) => (
            <Reveal
              key={step.n}
              delay={i * 0.08}
              className="group relative bg-surface p-8 transition-colors hover:bg-mist"
            >
              <span className="font-mono text-[14px] font-semibold text-steel">
                {step.n}
              </span>
              <div className="mt-6 h-px w-8 bg-steel/30 transition-all duration-500 group-hover:w-14 group-hover:bg-steel" />
              <h3 className="mt-5 text-[16px] font-semibold uppercase tracking-wide text-ink">
                {step.title}
              </h3>
              <p className="mt-3 text-[13.5px] leading-[1.75] text-slatetx">
                {step.body}
              </p>
            </Reveal>
          ))}
        </div>

        {/* Principles strip */}
        <div className="mt-8 grid grid-cols-2 gap-y-4 border-t border-hairline pt-6 sm:flex sm:flex-wrap sm:items-center sm:gap-x-10">
          {principles.map((p) => (
            <span
              key={p}
              className="flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.14em] text-steel"
            >
              <span className="h-1 w-1 rounded-full bg-platinum" aria-hidden />
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
